module.exports = __webpack_public_path__ + "img/front_neck_depth.5725cde0.png";